<template>
    <div>
        <vxe-grid ref="table-m1" v-bind="vxeOption" :footer-data="footerData">
            <!-- 表单（搜索条件或操作按钮） -->
            <template #form>
                        <div class="clearfix screen-btns">
                          <div class="fl">
                            <vxe-button status="primary" class="button-sty" icon="el-icon-upload2"  @click="$refs.excelUpload.show()" >
                              导入
                            </vxe-button>
                            <vxe-button status="primary" class="button-sty" icon="el-icon-bottom"
                                  @click="doExcel">批量导出
                            </vxe-button>
                            <!-- <vxe-button status="primary" class="button-sty" icon="el-icon-download" @click="importExcel">导入</vxe-button> -->
                          </div>
                          <div class="fr">
                            <vxe-button icon="el-icon-brush" class="button-sty"  @click="resetEvent" type="text" status="primary" plain >重置</vxe-button>
                            <vxe-button status="warning"  icon="el-icon-search"
                              class="button-sty" @click="searchEvent">搜索</vxe-button>
                          </div>
                        </div>
                         <vxe-form ref="form" class="screen-box" title-width="92px" title-align="right" :data="formData"
                          @submit="toFilterData" @keyup.enter.native="toFilterData" @reset="searchEvent">
            		          <vxe-form-item title="话单日期:" field="name">
                                <template v-slot>
                                  <el-date-picker style="width: 17vw;" v-model="formData.cdrDate" type="daterange" align="right"
                                                  unlink-panels range-separator="-"
                                                  :picker-options="pickerOptions" value-format='yyyy-MM-dd'>
                                  </el-date-picker>
                                  <span>
                                    <i class="el-icon-sort-down icon_w" style="color:#00c4b3"
                                        @click="creationTimeSortEvent(2)"></i>
                                    <i class="el-icon-sort-up" style="color:#00c4b3"
                                        @click="creationTimeSortEvent(1)"></i>
                                    </span>
</template>
                  </vxe-form-item>
                <vxe-form-item title="类型:" field="cdrType" >
<template v-slot>
    <el-select v-model="formData.type"  >
        <el-option value="time" label="半小时"></el-option>
        <el-option value="date" label="每日"></el-option>
        <el-option value="week" label="每周"></el-option>
        <el-option value="month" label="每月"></el-option>
    </el-select>
</template>
                            </vxe-form-item>
              </vxe-form>
    </template>
      <!-- 分页 -->
<template #pager>
    <pager ref="pager" :page-sizes="pageSizes" @changeTablePage="changeTablePage">

    </pager>
</template>

      <!-- 行项目 -->
<template #option>

</template>
    </vxe-grid>

    <!--excel 模板导入 -->
    <excel-upload
      ref="excelUpload"
      title="数据导入"
      url="/basic/cdr/importData"
      @refreshDataList="refreshChange"
    ></excel-upload>
  </div>
</template>

<script>
import { VattiCdrCountColumns, VattiCdrCountDateColumns, VattiCdrCountTimeColumns } from "@/views/workorder/callcenter/cdr/option/tableColumns";
import ExcelUpload from "@/components/upload/excel";
import pager from "@/components/pager/index.vue";
import { initVxeTable } from '@/const/crud/admin/table';
import dayjs from 'dayjs';
import {
  doCheckExcle,
  doDownLoadExcle
} from "@/api/intfDownloadRecord/downloadRecord";
export default {
    components: {
        pager,
        ExcelUpload,
    },
    data() {
        return {
            footerData: [{ seq: '合计', num: '282' }],
            total: 0,


            requestParam: {
                cdrDate: null,
                cdrDateBegin: null,
                cdrDateEnd: null,
                type: "date",
                searchCount: false, // 是否分页
                current: 1, // 当前页面
                size: 0, // 页面数据量
            },
            formData: {
                cdrDate: null,
                cdrDateBegin: null,
                cdrDateEnd: null,
                type: 'date'
            },

            dataId: 0,
            vxeOption: {},
            // 查询参数
            pageSizes: [10, 20, 100],
            showEdit: false,
            tableData: [],
            columns: [],
            pickerOptions: {

                shortcuts: [{
                    text: '最近一周',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近一个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                        picker.$emit('pick', [start, end]);
                    }
                }, {
                    text: '最近三个月',
                    onClick(picker) {
                        const end = new Date();
                        const start = new Date();
                        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                        picker.$emit('pick', [start, end]);
                    }
                }]
            },
        };
    },
    methods: {
        changeTablePage(page, flag) {
            console.log("分页查询");
            this.requestParam.size = page.pageSize;
            this.requestParam.current = page.currentPage;
            this.requestParam.searchCount = flag;
            this.getTableData();
        },
        async getTableData() {
            //   await this.loadTabOption();
            this.$objCopy(this.formData, this.requestParam)
            this.requestParam.pageType = "";
            if(this.requestParam && this.formData
                &&!this.requestParam.cdrDateEnd&&!this.requestParam.cdrDateBegin){
                this.$message.error('请选择时间范围');
                return;
            }

            if((this.requestParam.type === 'date' ||this.requestParam.type === 'month')
            && this.daysBetween(this.requestParam.cdrDateBegin,this.requestParam.cdrDateEnd)>366){
                this.$message.error('时间范围不可超过1年');
                return;
            }else  if(this.requestParam.type === 'time'
            && this.daysBetween(this.requestParam.cdrDateBegin,this.requestParam.cdrDateEnd)>120){
                this.$message.error('时间范围不可超过120天');
                return;
            }else  if(this.requestParam.type === 'week'
            && this.daysBetween(this.requestParam.cdrDateBegin,this.requestParam.cdrDateEnd)>90){
                this.$message.error('时间范围不可超过90天');
                return;
            }

            let tableOption = {
                vue: this,
                tableRef: "table-m1",
                path: "/basic/cdr/smart/getListPage",
                param: this.requestParam,
                method: "post",
                columns: VattiCdrCountColumns,
            };
            if(this.formData.type === 'time'){
                tableOption.columns = VattiCdrCountTimeColumns;
            }else if(this.formData.type === 'date'){
                tableOption.columns = VattiCdrCountDateColumns;
            }else if(this.formData.type === 'week'){
                tableOption.columns = VattiCdrCountColumns;
            }else if(this.formData.type === 'month'){
                tableOption.columns = VattiCdrCountColumns;
            }
            this.vxeOption = initVxeTable(tableOption);

            this.flushed();
        },
        // //enter查询     this.searchValue = ''
        toFilterData() {
            // console.log(55,"触发了搜索");
            // 当用户没有输入内容就按enter键时，就return，不做任何操作，不去搜索
            if (this.formData === '') {
                return
            } else {
                // 请求查询接口，将列表展现出来
                this.searchEvent();
            }
        },
        // 搜索
        searchEvent() {
            //this.requestParam.buyChannelName = this.searchValue
            this.$objCopy(this.formData, this.requestParam)
            console.log(this.requestParam)
            this.$refs.pager.clearStoreTableDataTotal()
            this.requestParam.current = 1
            this.requestParam.searchCount = false
            this.$refs.pager.reset() // 重置分页器
            this.getTableData();
        },

        // 重置
        resetEvent() {
            let end = new Date();
            let start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            end = this.$formatDateTime(end, 'yyyy-MM-dd');
            start = this.$formatDateTime(start, 'yyyy-MM-dd');
            this.formData.cdrDate = [start, end]
            this.formData.cdrDateBegin = start;
            this.formData.cdrDateEnd = end;

            this.formData.type = "date";
            this.requestParam.current = 1
            this.requestParam.searchCount = false
            this.requestParam.type = 'date';
            this.requestParam.cdrDate = [start, end];
            this.requestParam.cdrDateBegin = start;
            this.requestParam.cdrDateEnd = end;

            this.$refs.pager.reset() // 重置分页器
            this.flushed()
        },
        // 刷新
        flushed() {
            this.$refs['table-m1'].commitProxy('reload');
        },
        refreshChange() {
            this.resetEvent()
        },
        //创建时间排序
        creationTimeSortEvent(val) {
            this.icon_T = !this.icon_T
            console.log('创建时间排序事件:', val)
            if (val == 1) {
                this.icon_T = false
            } else if (val == 2) {
                this.icon_T = true

            }
            this.formData.creationTimeSort = val;
            this.searchEvent();
        },
        doExcel() {
            this.$mask.open()
            doCheckExcle('呼叫中心话单统计').then(response => {
                if (response.data.msg == "success") {
                                this.$objCopy(this.formData, this.requestParam)
                    console.log(this.requestParam)

                    doDownLoadExcle("/basic/cdr/getListByExcel", this.requestParam).then(res => {
                        this.$mask.close()
                        this.$message({
                            type: res.data.type,
                            message: res.data.content
                        });
                    }).catch(() => {
                        this.$mask.close()
                    })
                } else {
                    this.$mask.close()
                    this.$message({
                        type: "error",
                        message: response.data.msg
                    });
                }
            }).catch(() => {
                this.$mask.close()
            })
        },
        daysBetween(dateString1, dateString2) {
            const day1 = dayjs(dateString1);
            const day2 = dayjs(dateString2);

            return day2.diff(day1, 'day');
        }
    },
    watch: {
        total(newVal, oldVal) {
            this.$refs.pager.tableDataTotal = newVal
        },
        'formData.cdrDate': {
            handler(newVal, oldVal) {
                if (newVal != null && newVal.length !== 0) {
                    this.formData.cdrDateBegin = newVal[0]
                    this.formData.cdrDateEnd = newVal[1]
                } else if (newVal == null) {
                    this.formData.cdrDateBegin = null
                    this.formData.cdrDateEnd = null
                }
            },
            deep: true,
        },


    },
    created() {
      let end = new Date();
      let start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      end = this.$formatDateTime(end, 'yyyy-MM-dd');
      start = this.$formatDateTime(start, 'yyyy-MM-dd');
      this.formData.cdrDate = [start, end]
      this.formData.cdrDateBegin = start;
      this.formData.cdrDateEnd = end;
    },
    mounted() {
    },
};
</script>

<style lang="scss">

</style>
